import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API;

// Test: Add response interceptor for testing
axios.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const subscriptionApi = {
  // Get organization users
  getOrganizationUsers: async (authtoken, orgId) => {
    console.log('---- getOrganizationUsers (subscription.api 17):', authtoken, orgId)
    try {
      const response = await axios.get(`${BASE_URL}/subscription/${orgId}/users`, {
        headers: {
          authtoken
        }
      });
      console.log('---- getOrganizationUsers (subscription.api 24):', response.data)
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch organization users');
    }
  },

  // Test: Get subscription details
  getSubscriptionDetails: async (authtoken, orgId) => {
    console.log('---- getSubscriptionDetails (subscription.api 32):', authtoken, orgId) 
    try {
      const response = await axios.get(`${BASE_URL}/subscription/${orgId}`, {
        headers: {
          authtoken
        }
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch subscription details');
    }
  },

  // Test: Update subscription
  updateSubscription: async (authtoken, orgName, data) => {
    console.log('---- updateSubscription (subscription.api 47):', authtoken, orgName, data)
    try {
      const response = await axios.post(`${BASE_URL}/subscription/${orgName}/update-terms`, data, {
        headers: {
          authtoken
        }
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to update subscription');
    }
  },

  // Test: Add users to organization
  addUsers: async (authtoken, orgId, users) => {
    console.log('---- addUsers (subscription.api 52):', authtoken, orgId, users)
    try {
      const response = await axios.post(`${BASE_URL}/subscription/${orgId}/users`, {
        users
      }, {
        headers: {
          authtoken
        }
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to add users');
    }
  },

  updateUserSubscriptionStatus: async (authtoken, orgId, userEmail, status) => {
    try {
        const response = await axios.post(`${BASE_URL}/subscription/${orgId}/${userEmail}/update-status`, {
            status
        }, {
            headers: {
                authtoken
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to update user status');
    }
  },

  createSubscription: async (authtoken, orgName, subscriptionData) => {
    console.log('---- createSubscription (subscription.api):', authtoken, orgName, subscriptionData);
    try {
      const response = await axios.post(
        `${BASE_URL}/subscription/${orgName}/create`,
        subscriptionData,
        {
          headers: {
            authtoken
          }
        }
      );
      console.log('createSubscription response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to create subscription:', error);
      throw new Error('Failed to create subscription');
    }
  },

  validateOrgSubscription: async (authtoken, orgName) => {
    console.log('---- validateOrgSubscription (subscription.api):', orgName);
    try {
      const response = await axios.get(
        `${BASE_URL}/subscription/${orgName}/validate-org`,
        {
          headers: { authtoken }
        }
      );
      console.log('validateOrgSubscription response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to validate organization subscription');
    }
  },

  validateUserSubscriptionByEmail: async (authtoken, userEmail) => {
    console.log('---- validateUserSubscriptionByEmail (subscription.api):', userEmail);
    try {
      const response = await axios.get(
        `${BASE_URL}/subscription/${userEmail}/validate-user`,
        {
          headers: { authtoken }
        }
      );
      console.log('validateUserSubscriptionByEmail response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to validate user subscription');
    }
  },

  changeSubscriptionLeaderByEmail: async (authtoken, orgName, userEmail) => {
    console.log('---- changeSubscriptionLeaderByEmail (subscription.api):', orgName, userEmail);
    try {
      const response = await axios.get(
        `${BASE_URL}/subscription/${orgName}/${userEmail}/change-leader`,
        {
          headers: { authtoken }
        }
      );
      console.log('changeSubscriptionLeaderByEmail response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to change subscription leader');
    }
  },

  removeUserFromSubscription: async (authtoken, orgName, userEmail) => {
    console.log('---- removeUserFromSubscription (subscription.api):', orgName, userEmail);
    try {
      const response = await axios.get(
        `${BASE_URL}/subscription/${orgName}/${userEmail}/remove-user`,
        {
          headers: { authtoken }
        }
      );
      console.log('removeUserFromSubscription response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to remove user from subscription');
    }
  },

  addUserToSubscription: async (authtoken, orgName, userEmail) => {
    console.log('---- addUserToSubscription (subscription.api):', orgName, userEmail);
    try {
      const response = await axios.get(
        `${BASE_URL}/subscription/${orgName}/${userEmail}/add-user`,
        {
          headers: { authtoken }
        }
      );
      console.log('addUserToSubscription response:', response.data);
      return response.data;
    } catch (error) {
      console.error('addUserToSubscription error details:', error.response?.data);
      if (error.response?.data?.error?.includes('not found in registry')) {
        throw new Error(`User ${userEmail} not found in registry. Please ensure user is properly registered before adding to subscription.`);
      }
      throw new Error('Failed to add user to subscription');
    }
  },

  renewSubscription: async (authtoken, orgName, renewalData) => {
    console.log('---- renewSubscription (subscription.api):', orgName, renewalData);
    try {
      const response = await axios.post(
        `${BASE_URL}/subscription/${orgName}/renew`,
        renewalData,
        {
          headers: { authtoken }
        }
      );
      console.log('renewSubscription response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to renew subscription');
    }
  },

  cancelSubscription: async (authtoken, orgName) => {
    console.log('---- cancelSubscription (subscription.api):', orgName);
    try {
      const response = await axios.get(
        `${BASE_URL}/subscription/${orgName}/cancel`,
        {
          headers: { authtoken }
        }
      );
      console.log('cancelSubscription response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to cancel subscription');
    }
  },

  updateSubscriptionStatus: async (authtoken, orgName, statusData) => {
    console.log('---- updateSubscriptionStatus (subscription.api):', orgName, statusData);
    try {
      const response = await axios.post(
        `${BASE_URL}/subscription/${orgName}/update-status`,
        statusData,
        {
          headers: { authtoken }
        }
      );
      console.log('updateSubscriptionStatus response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update subscription status');
    }
  },

  updateSubscriptionTerms: async (authtoken, orgName, termsData) => {
    console.log('---- updateSubscriptionTerms (subscription.api):', orgName, termsData);
    try {
      const response = await axios.post(
        `${BASE_URL}/subscription/${orgName}/update-terms`,
        termsData,
        {
          headers: { authtoken }
        }
      );
      console.log('updateSubscriptionTerms response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update subscription terms');
    }
  },

  updateSubscriptionPayment: async (authtoken, orgName, paymentData) => {
    console.log('---- updateSubscriptionPayment (subscription.api):', orgName, paymentData);
    try {
      const response = await axios.post(
        `${BASE_URL}/subscription/${orgName}/update-payment`,
        paymentData,
        {
          headers: { authtoken }
        }
      );
      console.log('updateSubscriptionPayment response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update subscription payment');
    }
  }
};